export function fromGlobalId(globalId: string): string {
	const decoded = atob(globalId.replace(/-/g, '+').replace(/_/g, '/'));
	const colonIndex = decoded.indexOf(':');
	if (colonIndex === -1) return globalId;
	return decoded.substring(colonIndex + 1);
}
